import {
  Alert,
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  Snackbar,
  Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { lazy, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  enterpriseDropdownBusinessesLimit,
  keywordOverviewTexts,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  paths,
  SEOSpaceLocal
} from 'src/common/config/TextMessage';
import {
  setBusinessNamesData,
  setIsConnectionFlow,
  setLocationListResponse,
  setLocationsDetailsLoader,
  setReduxFilteredLocationsData,
  setReduxLocationsData,
  setSelectedAccountId,
  setSelectedBusinessAccountId,
  setSelectedBusinessName,
  setSelectedBusinessNameFilter,
  setSelectedLocationId
} from 'src/redux/localSeo';
import { getCreditDetails, getLocations } from 'src/common/Scraper';
import {
  setIsAgencyUpgrade,
  setLocalSeoSection
} from 'src/redux/keywordResearch';
import { updateSearchesDetailsAndLimits } from 'src/common/config/FunctionHelperPartTwo';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import { GMBTutorialLinks, localSeoTexts } from './localSeoTexts';
import {
  keywordOverviewCss,
  snackBar
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import {
  getCookie,
  isLocalSeoUser,
  localStorageMethod,
  openNewTab
} from 'src/common/config/FunctionHelper';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Helmet } from 'react-helmet-async';
import { KeywordTrackingAllTexts } from '../keywordResearch/keywordTracking/KeywordTrackingAllTexts';
import {
  getLocalSeoBusinessId,
  getLocalSeoId,
  setLocalSeoBusinessId,
  setLocalSeoId
} from 'src/common/config/FunctionHelperPartTwo';
import { useBrowserType } from 'src/hooks/useBrowserType';
import { useChromeBrowserBanner } from 'src/hooks/useChromeBrowserBanner';
import Loader from 'src/common/config/Loader';
// Named Exports
const GoogleListingManager = Loader(
  lazy(() =>
    import('./GoogleListingManager').then((module) => ({
      default: module.GoogleListingManager
    }))
  )
);
const ListingPreview = Loader(
  lazy(() =>
    import('./ListingPreview').then((module) => ({
      default: module.ListingPreview
    }))
  )
);
const LocalSeoCommonLoader = Loader(
  lazy(() =>
    import('./LocalSeoCommonLoader').then((module) => ({
      default: module.LocalSeoCommonLoader
    }))
  )
);
const ConnectBusinessProfileModal = Loader(
  lazy(() =>
    import('./ConnectBusinessProfileModal').then((module) => ({
      default: module.ConnectBusinessProfileModal
    }))
  )
);
const UpgradeToAgency = Loader(
  lazy(() =>
    import('../keywordResearch/keywordTracking/UpgradeToAgency').then(
      (module) => ({ default: module.UpgradeToAgency })
    )
  )
);
const NewCommonChromeExtensionModal = Loader(
  lazy(() =>
    import('src/common/NewCommomChromeExtensionModal').then((module) => ({
      default: module.NewCommonChromeExtensionModal
    }))
  )
);

// Default Export
const BuySlotsCommonModal = Loader(
  lazy(() => import('src/common/LocalSeoCommonComponents/BuySlotsCommonModal'))
);
import { BusinessProfileSelector } from './BusinessProfileSelector';

export const ListingManagerDashboard = () => {
  const [googleAuthText, setGoogleAuth] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [creditLoader, setCreditLoader] = useState(null);

  let locationsData =
    useSelector((state: RootState) => state.localSeo.reduxLocationsData) ??
    null;
  let locationsDetailsLoader =
    useSelector((state: RootState) => state.localSeo.locationsDetailsLoader) ??
    null;

  let reduxFilteredLocationsData =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? null;

  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency =
    activePlanName === planDetails?.agency ||
    activePlanName === planDetails?.expertPlus ||
    activePlanName === planDetails?.enterprise;
  let selectedBusinessName: any =
    useSelector((state: RootState) => state.localSeo.selectedBusinessName) ??
    '';
  const match = reduxFilteredLocationsData?.find(
    (location) => location?.title === selectedBusinessName
  );

  const localStorageSeoId = getLocalSeoId();
  const refreshMatch = reduxFilteredLocationsData?.find(
    (location) =>
      location?.name === localStorageSeoId && location?.temp !== true
  );
  const isEnterprise = activePlanName === planDetails?.enterprise;
  const [selectedAddress, setSelectedAddress]: any = useState(
    //refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    ''
  );
  const [showBuyLocalSeoSlot, setShowBuyLocalSeoSlot] = useState(null);
  // useEffect to set when redux data arrives
  useEffect(() => {
    if (!reduxFilteredLocationsData || reduxFilteredLocationsData?.length === 0)
      return;

    const refreshMatch = reduxFilteredLocationsData.find(
      (location) =>
        location?.name === localStorageSeoId && location?.temp !== true
    );

    setSelectedAddress(
      refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    );
  }, [reduxFilteredLocationsData, localStorageSeoId, match, refreshMatch]); // run when any of these change

  let selectedBusinessAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedBusinessAccountId
  );
  const isLocalSeo = isLocalSeoUser();
  const isLocalSeoUnlocked =
    useSelector((state: RootState) => state.localSeo.isLocalSeoUnlocked) ||
    isLocalSeo ||
    false;
  const isAgencyUpgrade =
    useSelector((state: RootState) => state.keywordResearch.isAgencyUpgrade) ??
    false;
  const locationListResponse =
    useSelector((state: RootState) => state.localSeo.locationListResponse) ??
    false;
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  const loader =
    useSelector((state: RootState) => state.siteAudit.loader) ?? true;
  // Check if the site audit loader is active
  const isFreePlan = activePlanName === planDetails.free;
  const isNoPlanAccount =
    !stripeLoader &&
    !loader &&
    userDetails?.email &&
    userDetails?.temp == true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);
  const isExpireAccount =
    !stripeLoader &&
    !loader &&
    !isFreePlan &&
    userDetails?.email &&
    userDetails?.temp !== true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);

  const isNoPlanOrExpire = isNoPlanAccount || isExpireAccount;

  const isNotPause =
    stripeSubscriptionDetails &&
    !stripeSubscriptionDetails?.pause_collection?.behavior;

  const { isChromeBrowser } = useBrowserType();
  const { NotAChromeBrowserBanner } = useChromeBrowserBanner();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const locationStoredId = getLocalSeoId();
  const locationStoredBusinessId = getLocalSeoBusinessId();
  const getLocalSeoCookieSqsp = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeoSqsp = getLocalSeoCookieSqsp === localSeoSignupSourceSqsp;
  const businessRef = useRef(null);
  const open = Boolean(anchorEl);

  const handleToggle = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };

  const seoSpaceChannel = new BroadcastChannel('SEO_Space');
  seoSpaceChannel.onmessage = (event) => {
    if (event?.data?.type === 'gbpc_auth_connection') {
      dispatch(setSelectedBusinessAccountId(event?.data?.accountId));
      setGoogleAuth(event.data);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (!locationsData) {
        await getLocationsDetails();
      }
    };

    fetchData();
    getCredits();
  }, []);
  useEffect(() => {
    if (
      googleAuthText?.message &&
      googleAuthText?.success &&
      location.pathname == paths?.listingManager &&
      selectedBusinessAccountId
    ) {
      dispatch(setIsConnectionFlow(true));
      dispatch(setLocalSeoSection(1));
      navigate(paths?.localChecker);
      // Clear the authentication message after 5 seconds
      setTimeout(() => {
        setGoogleAuth(null);
      }, 5000);
    }
  }, [googleAuthText]);

  //useEffect(() => {
  //  if (
  //    ((!selectedAccountId && !selectedLocationId) ||
  //      (!locationStoredId && !locationStoredBusinessId)) &&
  //    isLocalSeoSqsp
  //  ) {
  //    getLocationsDetails();
  //  }
  //}, [selectedAccountId, selectedLocationId]);

  //useEffect(() => {
  //  if (!selectedAddress || selectedAddress === '') {
  //    setSelectedAddress(reduxFilteredLocationsData?.[0]);
  //  }
  //}, [reduxFilteredLocationsData]);

  const getLocationsDetails = async (isConnecting = false) => {
    dispatch(setLocationsDetailsLoader(true));

    const squareSpaceSiteId = localStorageMethod('get', 'squareSpaceSiteId');
    const payload = {
      isConnecting,
      squareSpaceSiteId: squareSpaceSiteId ? squareSpaceSiteId : null
    };
    const getLocationsResponse: any = await getLocations(payload);
    dispatch(setLocationListResponse(getLocationsResponse));
    if (
      getLocationsResponse?.status == 'success' &&
      getLocationsResponse?.isGBPConnected
    ) {
      const locations = getLocationsResponse?.locations || [];
      // Filter only locations with selected === true
      const selectedLocations =
        locations?.filter(
          (location) => location?.selected === true && location?.temp !== true
        ) || [];

      // Dispatch filtered data to Redux
      dispatch(setReduxFilteredLocationsData(selectedLocations));
      dispatch(setReduxLocationsData(selectedLocations));
      dispatch(setSelectedBusinessName(selectedLocations[0]?.title));
      const locationStorageId = getLocalSeoId();
      const locationStorageBusinessId = getLocalSeoBusinessId();
      dispatch(
        setSelectedLocationId(
          locationStorageId ? locationStorageId : selectedLocations[0]?.name
        )
      );
      dispatch(
        setSelectedAccountId(
          locationStorageBusinessId
            ? locationStorageBusinessId
            : selectedLocations[0]?.accountId
        )
      );
      if (!locationStorageId && !locationStorageBusinessId) {
        setLocalSeoId(selectedLocations[0]?.name);
        setLocalSeoBusinessId(selectedLocations[0]?.accountId);
      }
      // Extract just the title values and dispatch
      const businessNames = locations?.map((loc) => loc?.title).filter(Boolean); // remove null/undefined
      dispatch(setBusinessNamesData(businessNames));
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    } else {
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    }
    dispatch(setLocationsDetailsLoader(null));
  };

  const handleSnackBarClose = () => {
    setGoogleAuth(null);
  };

  const breadcrumbs = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography key="2" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {localSeoTexts?.listingManager}
    </Typography>
  ];

  const handleSelect = (locationObj) => {
    setSelectedAddress(locationObj); // store the full object
    dispatch(setSelectedBusinessNameFilter(locationObj?.title));
    dispatch(setSelectedBusinessName(locationObj?.title));
    const matchedName = locationObj?.name || null;
    const matchedAccountId = locationObj?.accountId || null;
    setLocalSeoId(matchedName);
    setLocalSeoBusinessId(matchedAccountId);
    dispatch(setSelectedLocationId(matchedName));
    dispatch(setSelectedAccountId(matchedAccountId));
    setAnchorEl(null);
  };

  const handleCloseSnackBar = () => {
    dispatch(setIsAgencyUpgrade(false));
  };

  const getCredits = async () => {
    setCreditLoader(true);
    let getSearchesDetail: any = await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
    setCreditLoader(false);
  };
  return (
    <>
      {/* Set the page title using the Helmet component */}
      <Helmet>
        <title>
          {isLocalSeo
            ? `${SEOSpaceLocal} | Listing Manager`
            : localSeoTexts.listingManagerHelmetText}
        </title>
      </Helmet>
      {googleAuthText?.message && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={googleAuthText?.message}
          autoHideDuration={5000}
          onClose={handleSnackBarClose}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleSnackBarClose}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {googleAuthText?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {isAgencyUpgrade && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={isAgencyUpgrade}
          autoHideDuration={5000}
          onClose={handleCloseSnackBar}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleCloseSnackBar}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {KeywordTrackingAllTexts?.upgradeSuccessMessage}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {!isLocalSeo && NotAChromeBrowserBanner}

      {isChromeBrowser &&
        !isNoPlanOrExpire &&
        !isFreePlan &&
        isNotPause &&
        !isLocalSeo && (
          <>
            <NewCommonChromeExtensionModal />
          </>
        )}
      <Box sx={keywordOverviewCss?.breadcrumbsMainBoxNew}>
        <Box>
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={keywordResearchDashBoardCss?.navigateNextIcon}
              />
            }
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </Box>
        <Box sx={keywordOverviewCss?.userTutorialBox}>
          <img
            onClick={() => {
              openNewTab(keywordOverviewTexts?.keywordResearchTutorialsLink);
            }}
            src={
              process.env.PUBLIC_URL +
              `/static/images/icons/keyword/book-open-02.svg`
            }
            alt="icon"
          />
          <Typography
            onClick={() => {
              openNewTab(GMBTutorialLinks?.localSeoTutorial);
            }}
            sx={keywordOverviewCss?.userTutorial}
          >
            {localSeoTexts?.tutorialText}
          </Typography>
        </Box>
      </Box>
      {locationsDetailsLoader || creditLoader ? (
        <LocalSeoCommonLoader />
      ) : (
        <>
          {(isAgency || isLocalSeoUnlocked) &&
          reduxFilteredLocationsData?.length === 0 &&
          reduxFilteredLocationsData ? (
            <ConnectBusinessProfileModal />
          ) : (isAgency || isLocalSeoUnlocked) && reduxFilteredLocationsData ? (
            <>
              <BusinessProfileSelector
                selectedAddress={selectedAddress}
                locations={reduxFilteredLocationsData}
                isEnterprise={isEnterprise}
                enterpriseLimit={enterpriseDropdownBusinessesLimit}
                onSelect={handleSelect}
                onAddProfile={() => {
                  if (locationListResponse?.limitExceeded) {
                    setShowBuyLocalSeoSlot(true);
                  } else {
                    openNewTab(paths?.googleBusiness);
                  }
                }}
                onViewAll={() => {
                  navigate(paths?.localSeoBusinessListRoute);
                }}
                isExtraSx={true}
              />
              <Box
                sx={{
                  display: 'flex',
                  gap: '24px',
                  width: '100%'
                }}
              >
                <Box sx={{ width: '60%' }}>
                  <GoogleListingManager locationsData={locationsData} isDelete={selectedAddress?.isDelete} />
                </Box>
                <Box sx={{ width: '40%' }}>
                  <ListingPreview locationsData={locationsData} />
                </Box>
              </Box>
            </>
          ) : (isAgency || isLocalSeoUnlocked) &&
            (!locationsData || !reduxFilteredLocationsData) ? (
            <ConnectBusinessProfileModal />
          ) : !isAgency && !isLocalSeoUnlocked && activePlanName ? (
            <Card sx={{ ...keywordOverviewCss?.card }}>
              <CardContent sx={keywordOverviewCss?.cardContent}>
                <UpgradeToAgency isLocalSeo={true} isListing={true} />
              </CardContent>
            </Card>
          ) : (
            <LocalSeoCommonLoader />
          )}
        </>
      )}
      {showBuyLocalSeoSlot && (
        <BuySlotsCommonModal
          triggerOpen={true}
          onClose={() => setShowBuyLocalSeoSlot(false)}
          isLocalSeo={true}
        />
      )}
    </>
  );
};
